const MobileContactStrip = () => null;
export default MobileContactStrip;
